const landscapesData = [
    {
        category: 'landscapes',
        id: '1',
        alt: '',
        title: '',
        blurhash: 'LsLhA3xuRkj[~qRjM{ayIUWBWBfR',
        orientation: 'landscape'
    },
    {
        category: 'landscapes',
        id: '2',
        alt: '',
        title: '',
        blurhash: 'LkEN0OOu-:t7t:s8kCj]I^ROWXa~',
        orientation: 'landscape'

    },
    {
        category: 'landscapes',
        id: '3',
        alt: '',
        title: '',
        blurhash: 'LROmNT0h0#GY~8ENNHkW0}xZs:nP',
        orientation: 'landscape'

    },
    {
        category: 'landscapes',
        id: '4',
        alt: '',
        title: '',
        blurhash: 'LED]#l~q0000jD-;M{4n009E.8%g',
        orientation: 'landscape'
    },
    {
        category: 'landscapes',
        id: '5',
        alt: '',
        title: '',
        blurhash: 'LJ97kdjYM|fQ_4f5WBj[OGays:j[',
        orientation: 'landscape'
    },
    {
        category: 'landscapes',
        id: '6',
        alt: '',
        title: '',
        blurhash: 'LUH8~JWo9]s.}XazWCoLjsoKoLWV',
        orientation: 'portrait'
    },
    {
        category: 'landscapes',
        id: '7',
        alt: '',
        title: '',
        blurhash: 'L8CiN~}?0fIrO]Ndr;j[0358=wxs',
        orientation: 'landscape'
    },
    {
        category: 'landscapes',
        id: '8',
        alt: '',
        title: '',
        blurhash: 'L01C$rROQ+o~ROj[kXj[jEkCWBae',
        orientation: 'landscape'
    },
    {
        category: 'landscapes',
        id: '9',
        alt: '',
        title: '',
        blurhash: 'LB2?EuogjWWCOxWUjWoeWFadaybI',
        orientation: 'landscape'
    },
    {
        category: 'landscapes',
        id: '10',
        alt: '',
        title: '',
        blurhash: 'LtFi40xZRkj[~Vt7WCj[?Ht7ayj[',
        orientation: 'landscape'
    },
    {
        category: 'landscapes',
        id: '11',
        alt: '',
        title: '',
        blurhash: 'L03[uOx^4nr;_NROM_Si00kD-;xF',
        orientation: 'landscape'
    },
    {
        category: 'landscapes',
        id: '12',
        alt: '',
        title: '',
        blurhash: 'LfH,P0MeI@t6}@RPa}s:5nbFoeoJ',
        orientation: 'landscape'
    },
    {
        category: 'landscapes',
        id: '13',
        alt: '',
        title: '',
        blurhash: 'L89aBQ0000?b-;M{Rjt700?b~qD%',
        orientation: 'landscape'
    },
    {
        category: 'landscapes',
        id: '18',
        alt: '',
        title: '',
        blurhash: 'L14xoP?Yh{H;00R7tmpL00E2NJ%h',
        orientation: 'landscape'
    },
    {
        category: 'landscapes',
        id: '14',
        alt: '',
        title: '',
        blurhash: 'L02YkmD{G1=.9D$@n0Nh0J$@wZN4',
        orientation: 'landscape'
    },
    {
        category: 'landscapes',
        id: '15',
        alt: '',
        title: '',
        blurhash: 'LYF$CX%MRjj[~pxuRjfQRjj[WBj[',
        orientation: 'landscape'
    },
    {
        category: 'landscapes',
        id: '16',
        alt: '',
        title: '',
        blurhash: 'LPFP4{WBE1WX~WWCRja}TKoJn$j[',
        orientation: 'landscape'
    },
    {
        category: 'landscapes',
        id: '17',
        alt: '',
        title: '',
        blurhash: 'L6E3C%?b00M{~qof%Mxu4nRjM{ay',
        orientation: 'landscape'
    },
];

export default landscapesData;
